import $ from 'jquery';

export default function init() {
  playSeriousSimplePodcastPlayerOnClick();
}

function playSeriousSimplePodcastPlayerOnClick() {
  var podcastPlayer = $('.podcast_player');

  podcastPlayer.on('click', function(event) {
    if (!$(this).hasClass('podcast_player--cover-hidden')) {
      event.stopPropagation();
      $(this).addClass('podcast_player--cover-hidden');
      $('button.play-btn').trigger('click');
    }
  });
}
